import React, {useEffect, useState } from "react";
import { getAllAdmins, patchAdmin } from "../../utils/helper";
import { alertSuccess, alertError } from "../../utils/alerts";
import Loader from "../../utils/Loader";

export default function AssignRoles() {
    const [employees, setEmployees] = useState(null);
    const [assignee, setAssignee] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getAllAdmins()
            .then((res) => { 
                setEmployees(res.data.data);  
            })
            .catch((err) => { 
                console.log(err.response)
            });
    }, []);

    const navigateById = (me) => {
        setAssignee(me)
    };

    const handleCategoryChange = (e) => {
        e.persist();
        if(e.target.checked){
            if (!assignee.categories.includes(e.target.value)) {
                setAssignee(prev => ({ ...prev, categories: [e.target.value, ...prev.categories]}))
            }
        } else {
            setAssignee((prev)=> ({
                ...prev,
                categories: prev.categories.filter(item => item !== e.target.value)
            }));
        }
    };


    const handleUpdateRoles = async (e) => {
        e.preventDefault();
        if (window.confirm("Note: Are you sure you want to proceed? Click OK to proceed.")) {
            const { _id, categories } = assignee;
            const data = { id: _id, categories };
            console.log(data)

            if(data.id && data.categories && data.categories.length > 2){
                setLoading(true);
                patchAdmin(data, data.id)
                .then((res) => {
                    if(res.data.success){
                        alertSuccess(res.data.message)
                    } else {
                        alertError(res.data.message)
                    }
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                })
                .catch((err) => {
                    alertError(err.response?.data?.error);
                    setLoading(false);
                    setTimeout(() => {
                        window.location.reload()
                    }, 2000);
                });
            }else {alert("Staff must have at least two permissions!");}
        } else {alert("Staff Permissions update was canceled!");}
    }

    return (
        <>            
            <h1 className="dash-title">Employees Management</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Assign Roles</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {employees && employees ? 
                                    <div className="table-responsive">
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr><th>SN</th><th>Staff Name</th><th>Staff Team</th><th>Assigned Roles</th><th>Action</th></tr></thead>
                                            <tbody>
                                                {employees && employees.map((staff, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{staff.first_name && staff.first_name} {staff.last_name && staff.last_name}</td>
                                                        <td>{staff.team && staff.team?.team_name} </td>
                                                        <td>{staff.categories && staff.categories.map((category, i) => (
                                                            <span key={i} 
                                                                className={category === "EMPLOYEE" ? `badge badge-success mr-2` : `badge badge-warning mr-2`}>
                                                                {category}
                                                            </span>
                                                        ))}</td>
                                                        
                                                        <td>
                                                            <button 
                                                                onClick={() => navigateById(staff)} 
                                                                className='btn btn-preview'
                                                                type="button" 
                                                                data-toggle="modal" 
                                                                data-target="#personalModal" 
                                                                disabled={staff.categories.includes("SUPER")}
                                                            >
                                                                <i className="fa fa-pencil"></i> Update Roles
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                </div> : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="personalModal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">UPDATE STAFF PERMISSIONS</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Staff First Name: <span>*</span></label>
                                    <input type="text" className="form-control" required placeholder="Staff First Name" disabled
                                    defaultValue={assignee?.first_name && assignee?.first_name }  />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Staff Last Name: <span>*</span></label>
                                    <input type="text" className="form-control" required placeholder="Staff Last Name" disabled
                                    defaultValue={assignee?.last_name && assignee?.last_name }  />
                                </div>

                                <div className="col-md-12 form-group">
                                    <label className="control-label">Staff Permissions: <span>*</span></label>
                                    <div className="control-group">
                                        <div className="controls span2">
                                            <label className="checkbox">
                                                <input 
                                                    type="checkbox" 
                                                    value="EMPLOYEE" 
                                                    id="perm" 
                                                    disabled
                                                    checked={assignee?.categories?.includes("EMPLOYEE")} 
                                                    onChange={handleCategoryChange} 
                                                /> EMPLOYEE
                                            </label>
                                            <label className="checkbox">
                                                <input 
                                                    type="checkbox" 
                                                    value="OUTSOURCING" 
                                                    id="perm" 
                                                    checked={assignee?.categories?.includes("OUTSOURCING")} 
                                                    onChange={handleCategoryChange} 
                                                /> OUTSOURCING
                                            </label>
                                            <label className="checkbox">
                                                <input 
                                                    type="checkbox" 
                                                    value="RECRUITMENT" 
                                                    id="perm" 
                                                    checked={assignee?.categories?.includes("RECRUITMENT")} 
                                                    onChange={handleCategoryChange} 
                                                /> RECRUITMENT
                                            </label>
                                            <label className="checkbox">
                                                <input 
                                                    type="checkbox" 
                                                    value="SALES" 
                                                    id="perm" 
                                                    checked={assignee?.categories?.includes("SALES")} 
                                                    onChange={handleCategoryChange} 
                                                /> SALES
                                            </label>
                                            <label className="checkbox">
                                                <input 
                                                    type="checkbox" 
                                                    value="HR" 
                                                    id="perm" 
                                                    checked={assignee?.categories?.includes("HR")} 
                                                    onChange={handleCategoryChange} 
                                                /> HR
                                            </label>
                                            <label className="checkbox">
                                                <input 
                                                    type="checkbox" 
                                                    value="ADMIN" 
                                                    id="perm" 
                                                    checked={assignee?.categories?.includes("ADMIN")} 
                                                    onChange={handleCategoryChange} 
                                                /> ADMIN
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleUpdateRoles}
                                    >
                                        Save Changes
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    );
}
